// @ts-check
import { addClass, addEvent, getAttr, hasClass, query, queryAll, remAttr, removeClass, removeEvent, setAttr } from 'matt-utils';

/**
 * Apertura/chiusura filtri
 */
export class CollFilt extends HTMLElement {

  /**
   * Apertura/chiusura filtri
   */
  constructor() {

    super();

    this._apriFilt = this._apriFilt.bind( this );
    this._chiudiBg = this._chiudiBg.bind( this );
    this._chiudiEsc = this._chiudiEsc.bind( this );
    this._changeEvt = this._changeEvt.bind( this );
    this._formSubmit = this._formSubmit.bind( this );
    this._formReset = this._formReset.bind( this );

    this._els = '#skip, #h__top, footer, #coll__sx, .h__bread-p, #coll__list, .coll__loader-wrap';

  }

  /**
   * Elemento connesso
   */
  connectedCallback() {

    queryAll( '.h__bread-p', this ).forEach( ( el ) => {
      addEvent( el, 'click', this._apriFilt );
    });

    addEvent( query( '#coll__filt-bg', this ), 'click', this._chiudiBg );
    addEvent( query( '#coll__filt-chiudi', this ), 'click', this._chiudiBg );
    addEvent( window, 'keydown', this._chiudiEsc );

    const _this = this;

    queryAll( 'input, select', this ).forEach( ( el ) => {
      addEvent( el, 'change', _this._changeEvt );
    });

    addEvent( query( '#coll__filt', this ), 'submit', this._formSubmit );
    addEvent( query( '#coll__filt-res', this ), 'click', this._formReset );

  }

  /**
   * Elemento disconnesso
   */
  disconnectedCallback() {

    queryAll( '.h__bread-p', this ).forEach( ( el ) => {
      removeEvent( el, 'click', this._apriFilt );
    });
    removeEvent( query( '#coll__filt-bg', this ), 'click', this._chiudiBg );
    removeEvent( query( '#coll__filt-chiudi', this ), 'click', this._chiudiBg );
    removeEvent( window, 'keydown', this._chiudiEsc );

    const _this = this;

    queryAll( 'input, select', this ).forEach( ( el ) => {
      removeEvent( el, 'change', _this._changeEvt );
    });

    removeEvent( query( '#coll__filt', this ), 'submit', this._formSubmit );
    removeEvent( query( '#coll__filt-res', this ), 'click', this._formReset );

  }

  /**
   * Apri filtri
   *
   * @param {Event} evt - evento
   */
  _apriFilt( evt ) {

    evt.preventDefault();

    const target = evt.target.closest( '.coll__filt-a' ),
      dataInd    = getAttr( target, 'data-ind' );

    if ( dataInd !== null && !query( `.coll__filt-row[data-ind="${dataInd}"]` ).open )
      query( `.coll__filt-row[data-ind="${dataInd}"] summary` ).click();

    const filtri = query( '#coll__filt-wrap', this );

    addClass( filtri, 'open' );
    setAttr( filtri, 'aria-hidden', 'false' );
    setAttr( filtri, 'aria-expanded', 'true' );

    addClass( query( '.coll__head-wrap' ), 'open-men' );

    filtri.focus();

    queryAll( this._els ).forEach( ( el ) => {
      setAttr( el, 'inert', '' );
    });


  }

  /**
   * Click su nero o su chiudi
   *
   * @param {Event} evt - evento
   */
  _chiudiBg( evt ) {

    evt.preventDefault();

    this._chiudiFilt();

  }

  /**
   * Chiusura su esc
   *
   * @param {Event} evt - evento
   */
  _chiudiEsc( evt ) {

    if ( !hasClass( query( '#coll__filt-wrap', this ), 'open' ) )
      return;

    if ( evt.key !== 'Escape' )
      return;

    this._chiudiFilt();

  }

  /**
   * Chiudi filtro
   */
  _chiudiFilt() {

    const filtri = query( '#coll__filt-wrap', this );

    removeClass( query( '#coll__filt-wrap', this ), 'open' );
    setAttr( filtri, 'aria-hidden', 'true' );
    setAttr( filtri, 'aria-expanded', 'false' );

    removeClass( query( '.coll__head-wrap' ), 'open-men' );

    query( '.h__bread-p', this ).focus();

    queryAll( this._els ).forEach( ( el ) => {
      remAttr( el, 'inert' );
    });

  }

  /**
   * Fetch per filtri
   *
   * @param {string} url - URL
   */
  #_fetchUrl( url ) {

    const collList = query( '#coll__list' );

    addClass( collList, 'loading' );
    addClass( query( '#coll__filt-filt', this ), 'loading' );

    fetch( url, {
      credentials: 'same-origin', // include, *same-origin, omit
      headers: {
        'Content-Type': 'application/json',
      },
      method:      'GET',
    })
      .then( ( res ) => res.text() )
      .then( ( res ) => {

        const newHtml = document.createElement( 'html' );
        newHtml.innerHTML = res;

        removeClass( query( '#coll__filt-filt', this ), 'loading' );

        collList.innerHTML = query( '#coll__list', newHtml ).innerHTML;

        const newFiltri = queryAll( '.coll__filt-lab', newHtml );

        queryAll( '.coll__filt-lab' ).forEach( ( el, ind ) => {

          const currInp = query( 'input', el ),
            newInp      = query( 'input', newFiltri[ind]);

          if ( hasClass( newFiltri[ind], 'coll__filt-dis' ) ) {

            addClass( el, 'coll__filt-dis' );
            setAttr( currInp, 'disabled', 'true' );

          } else {

            removeClass( el, 'coll__filt-dis' );
            remAttr( currInp, 'disabled' );

          }

          currInp.checked = newInp.checked;

        });

        newHtml.remove();

        removeClass( collList, 'loading' );

      });

  }

  /**
   * Evento cambio filtri
   */
  _changeEvt() {

    const formData = new FormData( query( '#coll__filt', this ) ),
      urlParams    = new URLSearchParams( formData ).toString(),
      newurl       = `${location.protocol}//${location.host}${location.pathname}?${urlParams}`;

    window.history.replaceState({ path: newurl }, '', newurl );

    this.#_fetchUrl( `${location.pathname}?${urlParams}` );

  }

  /**
   * Click su applica filtri
   *
   * @param {Event} evt - evento
   */
  _formSubmit( evt ) {

    evt.preventDefault();

    this._changeEvt();
    this._chiudiFilt();

  }

  /**
   * Reset filtri
   *
   * @param {Event} evt - evento
   */
  _formReset( evt ) {

    evt.preventDefault();

    const newurl = `${location.protocol}//${location.host}${location.pathname}`;

    window.history.replaceState({ path: newurl }, '', newurl );

    this.#_fetchUrl( newurl );

  }
}

customElements.define( 'coll-filt', CollFilt );